/**
 * rangeFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function rangeFilter() {
    return function range(input, total) {
        total = parseInt(total);

        for (let i = 0; i < total; i++) {
            input.push(i);
        }

        return input;
    };
}
